import Vue from 'vue';
import Router from 'vue-router';
import PageNotFound from '@/pages/404';
import Home from '@/pages/Home';

import Page from '@/pages/Page';

import Class from '@/pages/Class';
import News from '@/pages/News';
import NewsSub from '@/pages/NewsSub';
import Video from '@/pages/Video';



import GuestBook from '@/pages/GuestBook';
import NewGuestBook from '@/pages/NewGuestBook';
import Photo from '@/pages/Photo';
import Site from '@/pages/Site';
import SiteInfo from '@/pages/SiteInfo';

import Journal from '@/pages/Journal';
import JournalContent from '@/pages/JournalContent';

import Team from '@/pages/Team';
import Member from '@/pages/Member';
import Administrative from '@/pages/Administrative';
import Teacher from '@/pages/Teacher';
import ClassItem from '@/pages/ClassItem';
import SignUp from '@/pages/SignUp';
import CoachInfo from '@/pages/CoachInfo';
import Facility from '@/pages/Facility';
import ClassInside from '@/pages/ClassInside';




import TeacherInfo from '@/pages/TeacherInfo';
import TeacherBasic from '@/pages/TeacherBasic';
import TeacherBook from '@/pages/TeacherBook';
import TeacherEdu from '@/pages/TeacherEdu';
import TeacherJournal from '@/pages/TeacherJournal';
import TeacherPrize from '@/pages/TeacherPrize';
import TeacherResearch from '@/pages/TeacherResearch';
import TeacherSeminar from '@/pages/TeacherSeminar';
import TeacherCustom from '@/pages/TeacherCustom';

import PhotoIn from '@/pages/PhotoIn';
import TeamType from '@/pages/TeamType';
import TeamInfo from '@/pages/TeamInfo';
import { syncLocaleFromUrl, langParamToLocale } from '@/assets/library/commonFunction';

// 進站依 hash ?L=EN / ?L=TW 設定語系（不帶參數一律中文）
syncLocaleFromUrl();
sessionStorage.locale = sessionStorage.locale || 'CH';

let title = {
  home: { CH: '首頁', EN: 'Home' },
  class: { CH: '運動指導班', EN: 'Class' },
  class_item: { CH: '報名班別', EN: 'Apply Class' },
  class_sign: { CH: '課程報名', EN: 'Class_Sign' },
  coach_info: { CH: '教練簡介', EN: 'Coach_Info' },
  facility: { CH: '場地設施', EN: 'Facility' },
  class_inside: { CH: '上課注意事項', EN: 'Note' },
  news: { CH: '最新消息', EN: 'News' },
  news_sub: { CH: '消息', EN: 'News' },
  video: { CH: '影片', EN: 'Video' },
  guest_book: { CH: '留言板', EN: 'Guest_book' },
  new_guest_book: { CH: '留言板', EN: 'Guest_book' },
  photo: { CH: '相簿', EN: 'Photo' },
  photo_in: { CH: '相簿', EN: 'Photo_In' },
  site: { CH: '場地介紹', EN: 'Site' },
  site_info: { CH: '場地', EN: 'Site_Info' },
  team: { CH: '體育代表隊介紹', EN: 'Team' },
  team_type: { CH: '體育代表隊', EN: 'TeamType' },
  team_info: { CH: '代表隊介紹', EN: 'Team_Info' },
  journal: { CH: '期刊及學報', EN: 'Journal' },
  journal_info: { CH: '內容', EN: 'Journal_Info' },
  member: { CH: '成員介紹', EN: 'member' },
  administrative: { CH: '行政成員介紹', EN: 'AdministrativeMember' },
  teacher: { CH: '師資介紹', EN: 'Teacher' },
  teacher_basic: { CH: '個人資料', EN: 'Teacher_Basic' },
  teacher_book: { CH: '專書及專書論文', EN: 'Teacher_Book' },
  teacher_edu: { CH: '學歷＆課程', EN: 'Teacher_Edu' },
  teacher_journal: { CH: '期刊論文', EN: 'Teacher_Journal' },
  teacher_prize: { CH: '獲獎＆學歷', EN: 'Teacher_Prize' },
  teacher_research: { CH: '專題研究報告及其他', EN: 'Teacher_Research' },
  teacher_seminar: { CH: '研討會論文', EN: 'Teacher_Seminar' },
  teacher_custom: { CH: '師資介紹', EN: 'Teacher_Custom' },
  page: { CH: '其他頁面', EN: 'Page' },
}




import VueBreadcrumbs from 'vue-breadcrumbs';


Vue.use(Router)
Vue.use(VueBreadcrumbs)

export const router = new Router({
  linkActiveClass: 'active',
  routes: [
    // { path: '*', redirect: '/404' },
    {
      path: '/404',
      name: '404',
      meta: { title: 'Page not found' },
      component: PageNotFound
    },
    {
      path: '/',
      name: 'home',
      meta: {
        title: '國立臺灣大學體育室',
        keepAlive: true,
        breadcrumb: title.home[sessionStorage.locale]
      },
      component: Home,
      children: [{
          path: 'class',
          name: 'class',
          meta: {
            title: title.class[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.class[sessionStorage.locale],
            keepAliveSub: false
          },
          component: Class,
          children: [{
            path: ':classid/class_item',
            name: 'class_item',
            meta: {
              title: title.class_item[sessionStorage.locale],
              keepAliveSub: true,
              keepAliveSub2: false,
              breadcrumb: title.class_item[sessionStorage.locale]
            },
            component: ClassItem,
            children: [{
                path: ':classname/:admissionsid/sign_up',
                name: 'class_sign',
                meta: {
                  title: title.class_sign[sessionStorage.locale],
                  keepAliveSub: true,
                  keepAliveSub2: true,
                  breadcrumb: title.class_sign[sessionStorage.locale]
                },
                component: SignUp
              },
              {
                path: ':classname/coach',
                name: 'coach_info',
                meta: {
                  title: title.coach_info[sessionStorage.locale],
                  keepAliveSub: true,
                  keepAliveSub2: true,
                  breadcrumb: title.coach_info[sessionStorage.locale]
                },
                component: CoachInfo
              },
              {
                path: ':classname/facility',
                name: 'facility',
                meta: {
                  title: title.facility[sessionStorage.locale],
                  keepAliveSub: true,
                  keepAliveSub2: true,
                  breadcrumb: title.facility[sessionStorage.locale]
                },
                component: Facility
              },
              {
                path: ':classname/note',
                name: 'class_inside',
                meta: {
                  title: title.class_inside[sessionStorage.locale],
                  keepAliveSub: true,
                  keepAliveSub2: true,
                  breadcrumb: title.class_inside[sessionStorage.locale]
                },
                component: ClassInside
              },
            ]
          }, ]
        },
        {
          path: 'news',
          name: 'news',
          meta: {
            title: title.news[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.news[sessionStorage.locale],
            keepAliveSub: false
          },
          component: News,
          children: [{
            path: ':newsid/news',
            name: 'news_sub',
            meta: {
              title: title.news_sub[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.news_sub[sessionStorage.locale]
            },
            component: NewsSub,
          }]
        },
        {
          path: 'video',
          name: 'video',
          meta: {
            title: title.video[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.video[sessionStorage.locale],
            keepAliveSub: false
          },
          component: Video
        },
        {
          path: 'guest_book',
          name: 'guest_book',
          meta: {
            title: title.guest_book[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.guest_book[sessionStorage.locale]
          },
          component: GuestBook
        },
        {
          path: 'new_guest_book',
          name: 'new_guest_book',
          meta: {
            title: title.new_guest_book[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.new_guest_book[sessionStorage.locale]
          },
          component: NewGuestBook
        },
        {
          path: 'photo',
          name: 'photo',
          meta: {
            title: title.photo[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.photo[sessionStorage.locale]
          },
          component: Photo,
          children: [{
            path: ':albumId/photo_in',
            name: 'photo_in',
            meta: {
              title: title.photo_in[sessionStorage.locale],
              keepAliveSub: true,
            },
            component: PhotoIn
          }]
        },
        {
          path: 'site',
          name: 'site',
          meta: {
            title: title.site[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.site[sessionStorage.locale]
          },
          component: Site,
          children: [{
            path: ':site/site_info',
            name: 'site_info',
            meta: {
              title: title.site_info[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.site_info[sessionStorage.locale]
            },
            component: SiteInfo
          }]
        },
        {
          path: 'team',
          name: 'team',
          meta: {
            title: title.team[sessionStorage.locale],
            keepAliveSub: true,
            breadcrumb: title.team[sessionStorage.locale]
          },
          component: Team,
          children: [{
            path: ':teamtypeid/team_type',
            name: 'team_type',
            meta: {
              title: title.team_type[sessionStorage.locale],
              keepAliveSub2: true,
              breadcrumb: title.team_type[sessionStorage.locale]
            },
            component: TeamType,
            children: [{
              path: ':teamid/team_info',
              name: 'team_info',
              meta: {
                title: title.team_info[sessionStorage.locale],
                keepAliveSub3: true,
                breadcrumb: title.team_info[sessionStorage.locale]
              },
              component: TeamInfo
            }]
          }]
        },
        {
          path: 'journal',
          name: 'journal',
          meta: {
            title: title.journal[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.journal[sessionStorage.locale]
          },
          component: Journal,
          children: [{
            path: ':journalid/content',
            name: 'journal_info',
            meta: {
              title: title.journal_info[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.journal_info[sessionStorage.locale]
            },
            component: JournalContent
          }]
        },
        {
          path: 'member',
          name: '',
          meta: {
            title: title.member[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.member[sessionStorage.locale]
          },
          component: Member,
          children: [{
              path: 'administrative',
              name: 'administrative',
              meta: {
                title: title.administrative[sessionStorage.locale],
                keepAlive: false,
                breadcrumb: title.administrative[sessionStorage.locale]
              },
              component: Administrative
            },
            {
              path: 'teacher',
              name: 'teacher',
              meta: {
                title: title.teacher[sessionStorage.locale],
                keepAlive: false,
                breadcrumb: title.teacher[sessionStorage.locale],
                keepAliveSub: false
              },
              component: Teacher,
              children: [{
                path: ':teacherid/',
                name: 'teacher_info',
                meta: {
                  title: 'xxx',
                  keepAliveSub: true
                },
                component: TeacherInfo,
                children: [{
                    path: 'basic',
                    name: 'teacher_basic',
                    meta: {
                      title: title.teacher_basic[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_basic[sessionStorage.locale]
                    },
                    component: TeacherBasic
                  },
                  {
                    path: 'book',
                    name: 'teacher_book',
                    meta: {
                      title: title.teacher_book[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_book[sessionStorage.locale]
                    },
                    component: TeacherBook
                  }, {
                    path: 'edu',
                    name: 'teacher_edu',
                    meta: {
                      title: title.teacher_edu[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_edu[sessionStorage.locale]
                    },
                    component: TeacherEdu
                  }, {
                    path: 'journal',
                    name: 'teacher_journal',
                    meta: {
                      title: title.teacher_journal[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_journal[sessionStorage.locale]
                    },
                    component: TeacherJournal
                  }, {
                    path: 'prize',
                    name: 'teacher_prize',
                    meta: {
                      title: title.teacher_prize[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_prize[sessionStorage.locale]
                    },
                    component: TeacherPrize
                  }, {
                    path: 'research',
                    name: 'teacher_research',
                    meta: {
                      title: title.teacher_research[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_research[sessionStorage.locale]
                    },
                    component: TeacherResearch
                  }, {
                    path: 'seminar',
                    name: 'teacher_seminar',
                    meta: {
                      title: title.teacher_seminar[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_seminar[sessionStorage.locale]
                    },
                    component: TeacherSeminar
                  },
                  {
                    path: ':custom',
                    name: 'teacher_custom',
                    meta: {
                      title: title.teacher_custom[sessionStorage.locale],
                      keepAliveSub: true,
                      breadcrumb: title.teacher_custom[sessionStorage.locale]
                    },
                    component: TeacherCustom
                  },
                ]
              }, ]
            },
          ]
        },
        {
          path: ':pageName',
          name: 'page',
          meta: {
            title: title.page[sessionStorage.locale],
            keepAlive: false,
            breadcrumb: title.page[sessionStorage.locale]
          },
          component: Page,
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  const toLang = to.query && to.query.L;
  const localeFromTo = langParamToLocale(toLang);

  // 目標網址已有 L：以 URL 為準
  if (localeFromTo) {
    sessionStorage.setItem('locale', localeFromTo);
    next();
    return;
  }

  // 從英文頁站內導向但漏帶 L 時，自動補上 ?L=EN（維持英文瀏覽）
  const fromIsEn = langParamToLocale(from.query && from.query.L) === 'EN';
  if (fromIsEn && sessionStorage.getItem('locale') === 'EN') {
    next({
      path: to.path,
      name: to.name,
      params: to.params,
      query: Object.assign({}, to.query, { L: 'EN' }),
      hash: to.hash,
      replace: true
    });
    return;
  }

  // 不帶 L：中文
  sessionStorage.setItem('locale', 'CH');
  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js